export default __webpack_public_path__ + "static/imageThirdSection-02a82ee09bb5d3a492352eb6d9d60c76.svg";